<div class="heading-flex">
  @if (variables && variables.welcome) {
  <p>{{variables.welcome}}, {{userName}}</p>
  }
</div>

@if (alertMessage?.importance > 0 ) {
<div class="holder" [ngClass]="'alertMessage'.concat(alertMessage?.importance)">
  <div class="inner">
    <div #news class="news">{{alertMessage?.message}}</div>
    <div #news class="news">{{alertMessage?.message}}</div>
  </div>
</div>
}
<div class="mat-card-group">
  <div>
    <mat-card class="example-card">
      <mat-card-header>
        <div class="header-image">
          <span class="card-image ">
            <mat-icon svgIcon="Folder" style="width:25px; height:25px;"></mat-icon>
          </span>
        </div>
        <div class="header-text">
          <mat-card-title>{{projects.length}}</mat-card-title>
          @if (variables && variables.projects) {
          <mat-card-subtitle>{{variables.projects}}</mat-card-subtitle>
          }
        </div>
      </mat-card-header>
    </mat-card>
  </div>
  <!--@if (authService.isAdmin() | async) {-->
  <div *hasPermission="Permission.PROJECT_MANAGE">
    <mat-card class="example-card">
      <mat-card-header>
        <div class="header-image">
          <span class="card-image ">
            <mat-icon svgIcon="Code" style="width:25px; height:25px;"></mat-icon>
          </span>
        </div>
        <div class="header-text">
          <mat-card-title>{{techCount}}</mat-card-title>
          @if (variables && variables.technologies) {
          <mat-card-subtitle>{{variables.technologies}}</mat-card-subtitle>
          }
        </div>
      </mat-card-header>
    </mat-card>
  </div>
  <!--}-->
  <div>
    <mat-card class="example-card">
      <mat-card-header>
        <div class="header-image">
          <span class="card-image  ">
            <mat-icon svgIcon="Clock" style="width:25px; height:25px;"></mat-icon>
          </span>
        </div>
        <div class="header-text">
          <mat-card-title>{{emcurso}}</mat-card-title>
          @if (variables && variables.onGoing) {
          <mat-card-subtitle>{{variables.onGoing}}</mat-card-subtitle>
          }
        </div>
      </mat-card-header>
    </mat-card>
  </div>
  <div>
    <mat-card class="example-card">
      <mat-card-header>
        <div class="header-image">
          <span class="card-image">
            <mat-icon svgIcon="Compliance" style="width:25px; height:25px;"></mat-icon>
          </span>
        </div>
        <div class="header-text">
          <mat-card-title>{{concluidas}}</mat-card-title>
          @if (variables && variables.finisheds) {
          <mat-card-subtitle>{{variables.finisheds}}</mat-card-subtitle>
          }
        </div>
      </mat-card-header>
    </mat-card>
  </div>
  <div>
    <mat-card class="example-card">
      <mat-card-header>
        <div class="header-image">
          <span class="card-image">
            <mat-icon svgIcon="certified" style="width:35px; height:35px;"></mat-icon>
          </span>
        </div>
        <div class="header-text">
          <mat-card-title>{{certified}}</mat-card-title>
          @if (variables && variables.finisheds) {
          <mat-card-subtitle>{{variables.certified}}</mat-card-subtitle>
          }
        </div>
      </mat-card-header>
    </mat-card>
  </div>
  <div>
    <mat-card style="cursor: pointer" class="example-card" routerLink="/stats">
      <mat-card-header>
        <div class="header-image">
          <span class="card-image estimates-done-image">
            <mat-icon svgIcon="Chart-Bar-Analytics" style="width:25px; height:25px;"></mat-icon>
          </span>
        </div>
        <div class="header-text">
          <mat-card-title style="opacity: 0;">></mat-card-title>
          @if (variables && variables.seeMore) {
          <mat-card-subtitle>{{variables.seeMore}}</mat-card-subtitle>
          }
        </div>
      </mat-card-header>
    </mat-card>
  </div>
</div>

<div class="dashboard-container-box">
  <app-dashboard-container></app-dashboard-container>
</div>

@if (variables && variables.allProjects && variables.newEstimateDashboard) {
<div class="bottom-table-buttons" *hasPermission="Permission.ESTIMATE_WRITE">
  <app-button routerLink="/estimativa" class="app-button" [typeBtn]="'primary'"
    message="{{variables.newEstimateDashboard}}"></app-button>
</div>
}